import * as React from 'react';

import Stack, { StackProps } from 'components/stack/stack';

type Props = {
  children: React.ReactNode;
  align?: StackProps['align'];
};
const CtaBoxActions: React.FC<Props> = ({ children, align = 'center' }) => {
  return (
    <div className="cta-box__actions">
      <Stack align={align}>{children}</Stack>
    </div>
  );
};

export default CtaBoxActions;
